import { Component, h } from '@stencil/core';

const COMPONENT_NAME = 'footer-menu-type-1';

/**
 * @slot title - <me-text variant="regular" weight="semi-bold">, <me-button variant="ghost">
 * @slot items - {required}, {multiply}, <me-button variant="ghost">, <me-socials showLabels="true">
 */
@Component({
  tag: 'footer-menu-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class FooterMenuType1 {
  render() {
    return (
      <nav class={COMPONENT_NAME}>
        <slot name="title"></slot>
        <div class={`${COMPONENT_NAME}__items`}>
          <slot name="items"></slot>
        </div>
      </nav>
    );
  }
}
